import React from 'react';
import { FiAward, FiShield, FiThumbsUp } from 'react-icons/fi';
import './WhyChooseUs.css';

const features = [
  {
    icon: FiAward,
    stat: '9 Years',
    label: 'In Business',
    description: 'Nearly a decade of trusted service and expertise in auto collision repair.'
  },
  {
    icon: FiShield,
    stat: 'Lifetime',
    label: 'Warranty',
    description: 'All repairs backed by our comprehensive lifetime warranty guarantee.'
  },
  {
    icon: FiThumbsUp,
    stat: '100%',
    label: 'Recommend',
    description: 'Perfect customer satisfaction with a 5.0 rating from all our clients.'
  }
];

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="why-choose-us section">
      <div className="container">
        <div className="why-choose-us__header">
          <h2 className="why-choose-us__title">Why Choose Axis Collision</h2>
          <p className="why-choose-us__subtitle">
            Your satisfaction and trust are our top priorities
          </p>
        </div>
        <div className="why-choose-us__grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-card__icon">
                <feature.icon />
              </div>
              <div className="feature-card__stat">{feature.stat}</div>
              <div className="feature-card__label">{feature.label}</div>
              <p className="feature-card__description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
